module.exports = __webpack_public_path__ + "~@/assets/img/3_find.2a2ca71a.png";